"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _defaultTo = _interopRequireDefault(require("lodash/defaultTo"));
var _excluded = ["size", "width", "height"];
// THD's specs on icons and their sizes can be found here:
// https://homedepot.invisionapp.com/dsm/the-home-depot/homedepot-com/folder/icons/5b8555d5cd75c3001b43de48?version=5e7cfe84c65eb42db22dfccc
var sizeMultipliers = {
  sm: 1,
  md: 1.4,
  lg: 1.7
};

/**
 * Returns a commponent that takes an optional `size` prop.
 * If width or height props are explicitly given, they win.
 *
 * smWidth and/or smHeight should typically be around 25px.
 */
var withSizePresets = function withSizePresets(smWidth, smHeight) {
  return function (Component) {
    var SizedSvg = function SizedSvg(_ref) {
      var size = _ref.size,
        width = _ref.width,
        height = _ref.height,
        rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      var multiplier = sizeMultipliers[size] || sizeMultipliers.sm;
      var w = (0, _defaultTo["default"])(width, smWidth * multiplier);
      var h = (0, _defaultTo["default"])(height, smHeight * multiplier);
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
        width: w,
        height: h
      }, rest));
    };
    SizedSvg.propTypes = {
      size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
      width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
      height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    };
    SizedSvg.defaultProps = {
      size: 'sm',
      width: undefined,
      height: undefined
    };
    SizedSvg.displayName = "SizedSvg(".concat(Component.name, ")");
    return SizedSvg;
  };
};
var _default = withSizePresets;
exports["default"] = _default;
//# sourceMappingURL=withSizePresets.js.map